import React, { FC, useCallback } from 'react';
import classNames from 'classnames';
import { findFromSelectorOptions, mainDateFormat } from '@core/utils/methods';
import { Modal, PrimaryButton } from '@shared/modules';
import { DirectMessageViewerProps } from '../../models';

import './styles.scss';

export const DirectMessageViewer: FC<DirectMessageViewerProps> = ({
  visible,
  onCancel,
  onCompleted,
  history,
  usersList,
  item,
}: DirectMessageViewerProps) => {
  const onFollow = useCallback((): void => {
    if (item) {
      history.push(item.notificationData.redirectLink);
    }
  }, [item, history]);

  const setCompleted = useCallback((): void => {
    if (item) {
      onCompleted(item._id);
    }
  }, [item, onCompleted]);

  return (
    <Modal
      title={`Direct Message${
        item
          ? ` - ${item.projectData.siteName}(${item.projectData.projectBundleID})`
          : ''
      }`}
      className="prov-direct-message-viewer"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <PrimaryButton
          key="cancel"
          type="default"
          title="Cancel"
          onClick={onCancel}
        />,
        <PrimaryButton key="follow" title="Follow" onClick={onFollow} />,
        <PrimaryButton
          key="set completed"
          title="Set Completed"
          onClick={setCompleted}
          disabled={item?.notificationData.isCompleted}
        />,
      ]}
    >
      <div className="prov-direct-message-viewer__content">
        <div className="item">
          <span className="item__label">Status</span>
          <span
            className={classNames(
              'item__value',
              item?.notificationData.isCompleted
                ? 'completed'
                : 'not-completed',
            )}
          >
            {item?.notificationData.isCompleted ? 'Completed' : 'Not Completed'}
          </span>
        </div>
        <div className="item">
          <span className="item__label">Sender</span>
          <span className="item__value">
            {findFromSelectorOptions(
              item?.notificationData.senderId || '',
              usersList,
            )}
          </span>
        </div>
        <div className="item">
          <span className="item__label">Area</span>
          <span className="item__value">{item?.notificationData.areaKey}</span>
        </div>
        <div className="item">
          <span className="item__label">Created</span>
          <span className="item__value">
            {mainDateFormat(item?.notificationData.createdAt)}
          </span>
        </div>
        <span className="message">{item?.notificationData.message}</span>
      </div>
    </Modal>
  );
};
